/** Where MCP clients reach hugo: the API's `/api/mcp` on this server (or the native app's API). */
export function mcpUrl(origin: string): string {
  return `${origin.replace(/\/+$/, '')}/api/mcp`
}

/** The one command that adds hugo to Claude Code, with the token as a bearer header. */
export function mcpAddCommand(origin: string, secret: string): string {
  return `claude mcp add --transport http hugo ${mcpUrl(origin)} --header "Authorization: Bearer ${secret}"`
}
